import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  activeFilters: {},
  merchantFacadePicturesList: [],
  currentPage: 1,
  prevPage: -1,
  nextPage: -1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_MERCHANT_FACADE_PIC_LIST":
      return setMerchantFacadeList(state, action);
    case "SET_ACTIVE_FILTERS_MERCHANT_FACADE":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_MERCHANT_FACADE":
      return setCurrentPageMerchantFacade(state, action);
    case "RESET_STATE_MERCHANT_FACADE":
      return resetStateMerchantFacade(state, action);
    default:
      return state;
  }
}

const setCurrentPageMerchantFacade = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setMerchantFacadeList = (state, action) => {
  return {
    ...state,
    merchantFacadePicturesList: getPath(
      action.payload,
      "data.merchant_facade_images",
      []
    ),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};

const resetStateMerchantFacade = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
